import styled from 'styled-components';

const NavItemsContainer = styled.div`
  width: 100%;
  position: relative;
`;
const NavItem = styled.div`
  background-color: ${({ label }) => (label === 'Solutions' ? '#F6F8FA' : 'var(--white)')};
  cursor: ${({ label }) => (label !== 'Solutions' ? 'pointer' : 'auto')};
  height: 56px;
  width: 100%;
  ${({ index }) => index === 0 && `border-top: 1px solid var(--grey-2);`}
  border-bottom: 1px solid var(--grey-2);
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  .nav-item--title {
    margin: 0;
  }
  .arrow-container {
    position: relative;
    svg {
      position: absolute;
      right: 0;
      top: -1px;
      height: 18px;
    }
  }
`;

const SolutionNavItemsContainer = styled.div`
  width: 100%;
  padding: 20px 30px;
  background-color: #f6f8fa;
  .solutions-nav-item {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &:first-child {
      margin-bottom: 15px;
    }

    .solutions-nav-item--copy {
      margin-bottom: ${({ index }) => (index === 0 ? '20px' : '')};
      .solutions-nav-item--title {
        margin-bottom: 10px;
      }
    }

    .solutions-arrow-container {
      position: relative;
      display: flex;
      align-items: center;
      svg {
        height: 18px;
      }
    }
  }
`;
const ButtonsContainer = styled.div`
  padding: 20px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--white);
  a {
    p {
      margin: 0;
    }
  }
  .upgrade-btn {
    margin: 0 0 20px 0;
    width: 100%;
    border-radius: 2px !important;
    &.header-menu-cta {
      text-transform: none !important;
    }
    p {
      color: var(--white);
      margin: 2px 0 0;
    }
  }
  .sign-in-btn {
    width: 100%;
    border-radius: 2px !important;
    p {
      margin: 2px 0 0;
    }
  }
`;

export { NavItem, NavItemsContainer, SolutionNavItemsContainer, ButtonsContainer };
